// extracted by mini-css-extract-plugin
export const movie = "movie-module--movie--3yJ-W";
export const caption = "movie-module--caption--1k4PQ";